import _ from 'lodash';

const TYPES = [
  {
    id: 'Recipe',
    name: 'Recipe',
    icon: 'list-alt',
    newRoute: 'new-recipe',
  },
  {
    id: 'Restaurant',
    name: 'Restaurant',
    icon: 'utensils',
    newRoute: 'new-restaurant',
  },
];

export default {
  types: TYPES,

  getTypeName(id) {
    // throw if not found
    return this.getType(id).name;
  },
  getType(id) {
    return _.find(TYPES, ['id', id]);
  },
  getTypeIds() {
    return _.map(this.types, 'id');
  },
  getTypeFromRoute(to) {
    const parts = to.path.split('/');
    if (parts.length > 1) {
      const regex = new RegExp(parts[1], 'i');
      return _.find(TYPES, t => regex.test(t.id));
    }

    return null;
  },
};




// WEBPACK FOOTER //
// ./src/foodItem-types.js